<template>
  <el-card class="box-card mt10">
    <div class="date-item">
      <el-link :underline="false">订单统计</el-link>
      <div class="order-today">
        <el-link :type="orderToday === 1?'primary':''" :underline="false" @click="handleOrderToday(1)">今日</el-link>
        <el-link :type="orderToday === 2?'primary':''" :underline="false" @click="handleOrderToday(2)">本周</el-link>
        <el-link :type="orderToday === 3?'primary':''" :underline="false" @click="handleOrderToday(3)">本月</el-link>
        <el-date-picker @change="changeDate" v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </div>
    </div>
    <div class="order-cont">
      <div>订单发货量<br /><span>{{orderMoney.deliveryCount}}</span></div>
      <div>下单量<br /><span>{{orderMoney.orderCount}}</span></div>
      <div>退货量<br /><span>{{orderMoney.backOrderCount}}</span></div>
    </div>
  </el-card>
</template>

<script>
import echartsVue from './echarts.vue'
import homeStatisticsApi from '@/api/home'
import { getWeekDates, getMonthDates, timeForMat } from '@/utils/index'
export default {
  components: { echartsVue },
  data() {
    return {
      orderToday: 1, //1今日 2 本周 3 本月 自定义时间 10
      dateTime: [],
      startTime: '',
      endTime: '',
      orderMoney: {}
    }
  },
  created() {
    this.startTime = timeForMat('0')[0]
    this.endTime = timeForMat('0')[0]
    this.getfindCashMoney()
  },
  methods: {

    //现金金额统计
    getfindCashMoney() {
      let startTime = this.startTime + (this.orderToday === 10 ? '' : ' 00:00:00')
      let endTime = this.endTime + (this.orderToday === 10 ? '' : ' 23:59:59')
      homeStatisticsApi.findOrder({ startTime, endTime }).then(({ data }) => {
        this.orderMoney = data;
      })
    },
    handleOrderToday(type) {
      if (this.orderToday === type) return
      this.dateTime = []
      this.orderToday = type;
      if (type === 1) {
        this.startTime = timeForMat('0')[0]
        this.endTime = timeForMat('0')[0]
      } else if (type === 2) {
        this.startTime = getWeekDates()[0]
        this.endTime = getWeekDates()[1]
      } else if (type === 3) {
        this.startTime = getMonthDates()[0]
        this.endTime = getMonthDates()[1]
      }
      this.getfindCashMoney();
    },
    changeDate() {
      if (!this.dateTime) return
      if (this.dateTime && !this.dateTime.length) return
      this.orderToday = 10;
      this.startTime = this.dateTime[0]
      this.endTime = this.dateTime[1]
      this.getfindCashMoney();
    },
  },
}
</script>

<style lang="scss" scoped>
.date-item {
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .order-today {
    float: right;
  }
}
.order-cont {
  display: flex;
  margin: 20px 0;
  div {
    font-size: 16px;
    color: #000;
    width: 25%;
    display: inline-block;
    line-height: 50px;
    span {
      font-size: 48px;
    }
  }
}
.el-link {
  padding-right: 20px;
}
</style>